import React from 'react';
import './ConstructionManagement.css'; // Use the same CSS file
import useScrollToTop from './useScrollToTop';
import ReusableLanding from './ReusableLanding';
import image2 from '../img/kitchen_modern_classic.png';
import { FaUserShield, FaExclamationTriangle, FaFileContract, FaMedkit, FaUsersCog, FaCheckCircle, FaHeartbeat, FaGavel, FaSearch, FaClipboardCheck, FaChartLine } from 'react-icons/fa'; // Import relevant icons
import { Link } from 'react-router-dom';

const SafetyProtocolsCompliance = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Safety Protocols & Compliance"
                description="Ensuring a safe and compliant construction site is our top priority. At Housekaar, we adhere to stringent safety protocols and regulatory compliance to protect our workers and stakeholders."
            />
            <div className="management-page">
                <section className="services-overview">
                    <h2>Our Safety & Compliance Services</h2>
                    <p>We are committed to maintaining the highest standards of safety and compliance on every construction project.</p>
                    <ul className="services-list">
                        <li><FaUsersCog className="service-icon" /> <strong>Safety Training:</strong> Providing comprehensive and engaging safety training programs to equip all personnel with the knowledge and skills to work safely.</li>
                        <li><FaExclamationTriangle className="service-icon" /> <strong>Hazard Assessments:</strong> Conducting thorough hazard identification and risk evaluation processes to proactively mitigate potential dangers on the job site.</li>
                        <li><FaCheckCircle className="service-icon" /> <strong>Compliance Audits:</strong> Performing regular and detailed audits to ensure strict adherence to all relevant local, state, and national safety regulations and project-specific requirements.</li>
                        <li><FaMedkit className="service-icon" /> <strong>Emergency Response Plans:</strong> Developing, communicating, and implementing comprehensive emergency response plans to effectively handle any unforeseen incidents.</li>
                        <li><FaCheckCircle className="service-icon" /> <strong>Safety Equipment Management:</strong> Ensuring the proper provision, use, inspection, and maintenance of all necessary personal protective equipment (PPE) and safety gear.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Safety & Compliance</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="benefit-icon"><FaHeartbeat /></div>
                            <h3>Reduced Accidents</h3>
                            <p>Implementing proactive safety measures and protocols that significantly minimize the occurrence of workplace accidents, injuries, and near misses.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaGavel /></div>
                            <h3>Legal Compliance</h3>
                            <p>Ensuring full adherence to all applicable local, state, and national safety regulations and building codes, avoiding potential fines and legal repercussions.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaCheckCircle /></div>
                            <h3>Improved Morale</h3>
                            <p>Creating a safe, secure, and respectful work environment that boosts employee morale, productivity, and overall job satisfaction.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaSearch /></div>
                            <h3>Proactive Risk Mitigation</h3>
                            <p>Identifying and addressing potential safety hazards and compliance issues early in the project lifecycle, preventing them from escalating into larger problems.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaChartLine /></div>
                            <h3>Enhanced Project Efficiency</h3>
                            <p>Minimizing disruptions and delays caused by accidents or compliance violations, leading to smoother project workflows and on-time completion.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>Our systematic approach integrates safety and compliance into every stage of your project.</p>
                    <ol className="process-list">
                        <li><FaFileContract className="process-icon" /> <strong>Planning & Protocol Development:</strong> Developing comprehensive safety protocols, compliance plans, and site-specific safety manuals tailored to the unique requirements of your project.</li>
                        <li><FaUserShield className="process-icon" /> <strong>Training & Education:</strong> Conducting regular safety training sessions, toolbox talks, and awareness programs for all personnel, including subcontractors and visitors.</li>
                        <li><FaClipboardCheck className="process-icon" /> <strong>Implementation & Enforcement:</strong> Enforcing safety protocols rigorously on-site, conducting regular safety inspections, and addressing any non-compliance issues promptly.</li>
                        <li><FaChartLine className="process-icon" /> <strong>Monitoring & Continuous Improvement:</strong> Tracking safety performance metrics, analyzing incident reports, and continuously reviewing and improving our safety protocols and compliance measures.</li>
                    </ol>
                </section>

                <section className="get-started-cta">
                    <h2>Prioritize Safety and Compliance on Your Project</h2>
                    <p>
                        Contact us today to learn more about our comprehensive safety protocols and compliance services. Let us partner with you to ensure a safe, legally compliant, and successful construction project.
                    </p>
                    <Link to="/pricing">
                        <button className="custom-button">Contact Us</button>
                    </Link>
                </section>
            </div>
        </>
    );
};

export default SafetyProtocolsCompliance;